import { PaperClipIcon } from "@heroicons/react/20/solid";
import React from "react";

export const Attachments = ({ attachments }) => {
  return (
    <div className="w-full min-w-0 rounded-lg border border-wa-border bg-wa-panel p-4 sm:p-6 sm:col-span-2">
      <div className="mb-3 text-center text-lg font-semibold text-wa-text">
        Documenten
      </div>
      <ul
        role="list"
        className="divide-y divide-wa-border overflow-hidden rounded-md border border-wa-border bg-wa-panel2"
      >
        {attachments.map((attachment) => (
          <li
            key={attachment?.bestand}
            className="flex items-center justify-between gap-2 py-3 pl-3 pr-3 text-sm sm:pr-4"
          >
            <div className="flex min-w-0 flex-1 items-center">
              <PaperClipIcon
                aria-hidden="true"
                className="h-5 w-5 flex-shrink-0 text-wa-muted"
              />
              <span className="ml-2 min-w-0 flex-1 truncate text-wa-text">
                <span className="font-semibold">{attachment?.title}</span> (
                {attachment?.bestand})
              </span>
            </div>
            <div className="flex-shrink-0">
              <a
                href={attachment?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-sky-400 hover:text-sky-300"
              >
                Download
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
